import axios from 'axios';
import { from } from 'rxjs';

// The share API (backend sharing-runbook §6, multi-tenancy runbook Stage 7):
// v2, plain JSON, refusals as problem+json. Calls go through the global axios
// client (the session's token; its `locale` header is the invitation's
// fallback language) with skipCustomErrorHandling: the dialogs and pages show
// a refusal's `title` themselves. docId is the document's exposed id, and
// the share body's workspaceId the workspace's (share ids stay numeric).
const quiet = { skipCustomErrorHandling: true };
const api = () => `${globalConfig.api_URL}api/v2/private`;

class ShareService {
    // { workspaceId, recipients: [...], deadline?, message?, insideOrganization?,
    //   signerListing?, signerListingSignature? } -> 201 { shares: [...] }
    share = (docId, body) => from(axios.post(`${api()}/document/${docId}/shares`, body, quiet));

    // newest first; all=true is the history; filters: permission (READ|SIGN),
    // insideOrganization (true|false), q (part of the recipient's address, at
    // most 254 characters). Pass pageInfo.next as cursor until it is null: the
    // cursor carries every filter and page size, and the backend ignores the
    // other parameters with it - a changed filter starts over without one.
    list = (docId, { all = false, cursor, pageSize, permission, insideOrganization, q } = {}) => {
        const params = {};
        if (cursor) params.cursor = cursor;
        else {
            params.all = all;
            if (pageSize) params['page-size'] = pageSize;
            if (permission) params.permission = permission;
            if (insideOrganization === true || insideOrganization === false)
                params['inside-organization'] = insideOrganization;
            if (q) params.q = q;
        }
        return from(axios.get(`${api()}/document/${docId}/shares`, { ...quiet, params }));
    };

    // the counts over the shares the caller may list -> { docId, active {total,
    // READ, SIGN, insideOrganization}, all {total}, states {<state>: n} }
    summary = (docId) => from(axios.get(`${api()}/document/${docId}/shares/summary`, quiet));

    // a fresh link mailed to the recipient -> { linkExpiresAt }
    freshLink = (docId, shareId) => from(axios.post(`${api()}/document/${docId}/shares/${shareId}/link`, null, quiet));

    // 204, again 204 when already withdrawn
    withdraw = (docId, shareId) => from(axios.delete(`${api()}/document/${docId}/shares/${shareId}`, quiet));

    // the recipient declines to sign -> { declinedAt, declineReason }
    decline = (docId, shareId, reason) =>
        from(axios.post(`${api()}/document/${docId}/shares/${shareId}/decline`, reason ? { reason } : {}, quiet));

    // an organization share's link, after the corporate login -> { shareId,
    // docId, workspaceId, organizationId }; the secret in the body, never a URL
    redeem = (secret) => from(axios.post(`${api()}/shares/redeem`, { secret }, quiet));
}

export default new ShareService();
